<template>
  <Modal
    class="mod-interrupt361"
    :width="350"
    :visible="visible"
    :closable="true"
    :append-to-body="true"
    :footer="null"
    @close="close"
  >
    <iframe v-if="visible" class="interrupt-iframe" :src="sourceUrl" />
  </Modal>
</template>
<script>
import Vue from 'vue'
import Modal from 'com/Modal'
import bus from 'src/eventbus'

const INT_CODE = 361
const INT_URL_FIELD = 'verification-url'
const INT_ALLOW_ORIGIN = /\.tradeup\.com$/
export default {
  name: 'Interrupt361',
  components: {
    Modal
  },
  data: () => ({
    visible: false,
    sourceUrl: null
  }),
  created() {
    this.addInterceptor()
  },
  beforeDestroy() {
    this.close()
  },
  methods: {
    addInterceptor() {
      Vue.http.interceptors.push((request, next) => {
        next(response => {
          if (response.status !== INT_CODE) return response

          const url = response.headers.get(INT_URL_FIELD)
          if (!url) return response

          this.sourceUrl = url
          this.open()
          return response
        })
      })
    },
    listenMessages(event) {
      if (!event.origin.match(INT_ALLOW_ORIGIN)) return

      const receivedData = event.data
      this.$debug('receive postMessages:', receivedData)

      if (
        typeof event.source === 'object' &&
        typeof event.source.close === 'function'
      ) {
        event.source.close()
        this.close(receivedData)
      }
    },
    open() {
      this.visible = true
      window.addEventListener('message', this.listenMessages, false)
    },
    close(reason) {
      this.visible = false
      window.removeEventListener('message', this.listenMessages, false)
      bus.emit(bus.$events.INTERCEPT_MESSAGE, reason)
    }
  }
}
</script>
<style lang="less">
.mod-interrupt361 {
  .interrupt-iframe {
    display: block;
    width: 100%;
    height: 400px;
  }
  .tt-modal-body {
    padding: 0;
  }
}
</style>
